import { withStyles } from '@material-ui/core/styles';
import { useRef } from 'react';
import { Button as MaterialButton } from '@material-ui/core';

// Estilo estático apenas para estados que não dependem de props (hover usa filter via Tailwind)
const CustomButton = withStyles({
  root: {
    borderRadius: '20px',
    textTransform: 'initial',
    fontFamily: 'Poppins',
    '&:disabled': {
      color: 'rgba(255, 255, 255, 0.25)',
      backgroundColor: 'rgba(255, 255, 255, 0.06)',
      borderColor: 'rgba(255, 255, 255, 0.15)',
    },
  },
})(MaterialButton);

let Button = props => {
  let ref = useRef(null);

  const {
    bgColor, customcolor, textcolor, padding, margintop, marginleft,
    marginright, width, border, fontfamily, variant, children, ...rest
  } = props;

  const bg = bgColor || customcolor || '#2a4f72';
  const tc = textcolor || '#e8f0fb';
  const isTransparent = bgColor === 'transparent';

  return <CustomButton
    className="filter hover:brightness-90"
    ref={ref}
    variant={variant || "contained"}
    style={{
      backgroundColor: isTransparent ? 'transparent' : bg,
      color: tc,
      border: border || undefined,
      borderColor: isTransparent ? tc : bg,
      padding: padding || "8px 22px",
      width: width || "100%",
      marginTop: margintop || "15px",
      marginLeft: marginleft || "0px",
      marginRight: marginright || "0px",
      fontFamily: fontfamily || 'Poppins',
    }}
    {...rest}
  >
    {children}
  </CustomButton>;
}

export default Button;
